import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MeetingDocumentModelDto } from '@shared/interfaces/dtos/meetings';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root',
})
export class MeetingDocumentsService extends BaseHttpService {
  protected endPoint: string = '';

  public fetchMeetingDocumentModels(meetingId: number): Observable<MeetingDocumentModelDto[]> {
    return this.http.get<MeetingDocumentModelDto[]>(
      this.buildURL({ overrideEndPoint: `Seances/${meetingId}/ModelesDocuments` })
    );
  }

  public generateMeetingDocument(
    meetingId: number,
    documentModelId: number,
    options?: { asPreview?: boolean; openAfterGeneration?: boolean }
  ): Observable<unknown> {
    const { asPreview = false, openAfterGeneration = false } = options || {};

    return this.http.post<unknown>(
      this.buildURL({ overrideEndPoint: `Seances/${meetingId}/ModelesDocuments/${documentModelId}/Generate` }),
      null,
      { params: { autoSave: !asPreview, openAfterGeneration } }
    );
  }

  public generateMeetingDocumentPreview(pointId: number, documentModelId: number): Observable<unknown> {
    return this.http.post<unknown>(
      this.buildURL({ overrideEndPoint: `Seances/${pointId}/ModelesDocuments/${documentModelId}/PreviewRequests` }),
      null
    );
  }

  public downloadMeetingDocumentPDF(meetingId: number, documentModelId: number): Observable<Blob> {
    return this.http.get<Blob>(
      this.buildURL({ overrideEndPoint: `Seances/${meetingId}/ModelesDocuments/${documentModelId}/DownloadPdf` }),
      { responseType: 'blob' as 'json' }
    );
  }

  public uploadMeetingDocumentRTF(config: {
    meetingId: number;
    documentModelId: number;
    file: File;
  }): Observable<unknown> {
    const formData = new FormData();
    formData.append('file', config.file);

    return this.http.post<unknown>(
      this.buildURL({
        overrideEndPoint: `Seances/${config.meetingId}/ModelesDocuments/${config.documentModelId}/UploadRtf`,
      }),
      formData
    );
  }

  public downloadMeetingDocumentRTF(meetingId: number, documentModelId: number): Observable<Blob> {
    return this.http.get<Blob>(
      this.buildURL({ overrideEndPoint: `Seances/${meetingId}/ModelesDocuments/${documentModelId}/DownloadRtf` }),
      { responseType: 'blob' as 'json', params: { generatedAndSaved: true } }
    );
  }
}
